export function localCurrency(num?: number | null){
    const numStr = num ? num : 0;
    return numStr.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
}

export function localNumber(num?: number | null){
    const numStr = num ? num : 0;
    return numStr.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
}


// WEBPACK FOOTER //
// ./src/utils/number-utils.ts